import { actions } from '@app/action/transfers';
import { normalizeTransfer } from '@module/transfer/build';

const initialState = {
  isLoaded: false,
  list: [],
  receivedTransfersList: [],
};

export default function(state = initialState, action) {
  const { type } = action;

  switch (type) {
    case actions.TRANSFERS_SUCCESS: {
      return {
        ...state,
        list: action.list.map(normalizeTransfer),
        isLoaded: true,
      };
    }

    case actions.GET_TRANSFER_SUCCESS:
      return {
        ...state,
        transfer: normalizeTransfer(action.transfer),
      };

    case actions.DOWNLOAD_TRANSFER_SUCCESS:
      // No detailed transfer is active, so no need to update
      if (!state.transfer) {
        return state;
      }

      return {
        ...state,
        transfer: {
          ...state.transfer,
          number_of_downloads: state.transfer.number_of_downloads + 1,
        },
      };

    case actions.TRANSFERS_RESET_TRANSFER:
      return {
        ...state,
        transfer: null,
      };

    case actions.TRANSFERS_RESET_LIST_LOADED:
      return {
        ...state,
        isLoaded: false,
      };
  }

  return state;
}
